/* eslint-disable no-unused-vars */
import React, { useEffect, useState, createContext } from "react";
import "./App.css";
import "./ModernGallery.css";
import { BrowserRouter as Router, Routes, Route, Link, useParams } from "react-router-dom";
import axios from "axios";
import ReactPlayer from "react-player";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import { RHAP_UI } from 'react-h5-audio-player';

// Components
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import About from "./About/About";
import Contact from "./Contact/Contact";
import { Home } from "./Home/Home";
import Lahlou from "./Lahlou/Lahlou";
import Image from "./POST/POST_Image/Image";
import Video from "./POST/POST_Video/Video";
import Audio from "./POST/POST_Audio/Audio";
import Donner from "./Donner/Donner";
import Center from "./Center/Center";
import ChatBotGemini from "./ChatBot/ChatBotGemini";
import Activities from "./Activities/Activities";
import ActivityDetail from "./Activities/ActivityDetail";
import VideosPage from "./VideosPage/VideosPage";
import PhotosPage from "./PhotosPage/PhotosPage";
import DepositStations from "./DepositStations/DepositStations";
import SectionsMenu from "./SectionsMenu/SectionsMenu";
import DetailPage from "./DetailPage/DetailPage";

// إنشاء سياق لإدارة تشغيل الفيديو
export const VideoContext = createContext();

// مكون منفصل لعرض ألبوم الصور
const ImageAlbum = () => {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showFullTitle, setShowFullTitle] = useState(false);

  useEffect(() => {
    const fetchImageAlbum = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`http://localhost:4444/images/${id}`);
        setData(res.data.data);
      } catch (error) {
        console.error("Error fetching image album:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchImageAlbum();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="album-container">
        <div className="loading-spinner">
          <i className="fas fa-spinner fa-spin"></i>
          <p>جاري تحميل الألبوم...</p>
        </div>
      </div>
    );
  }

  const currentImageIndex = selectedImage ? data.URLImages.indexOf(selectedImage) : -1;

  const handlePrevImage = (e) => {
    e.stopPropagation();
    if (currentImageIndex > 0) {
      setSelectedImage(data.URLImages[currentImageIndex - 1]);
    }
  };

  const handleNextImage = (e) => {
    e.stopPropagation();
    if (currentImageIndex < data.URLImages.length - 1) {
      setSelectedImage(data.URLImages[currentImageIndex + 1]);
    }
  };

  const titleText = data.title || 'ألبوم الصور';
  const isTitleLong = titleText.length > 100;

  return (
    <div className="modern-album-container">
      {/* Navigation Bar */}
      <div className="album-nav-bar">
        <Link to="/" className="modern-back-btn">
          <i className="fas fa-arrow-right"></i>
          <span>العودة</span>
        </Link>
        <div className="album-brand">
          <i className="fas fa-images"></i>
          <span>ANPE Maroc</span>
        </div>
      </div>

      {/* Album Header Card */}
      <div className="album-header-card">
        <div className="album-header-content">
          <div className="album-icon-wrapper">
            <i className="fas fa-folder-open"></i>
          </div>
          <div className="album-info">
            <div className="album-title-section">
              <h1 className={`modern-album-title ${!showFullTitle && isTitleLong ? 'truncated' : 'expanded'}`}>
                {titleText}
              </h1>
              {isTitleLong && (
                <button 
                  className="read-more-toggle"
                  onClick={() => setShowFullTitle(!showFullTitle)}
                >
                  {showFullTitle ? (
                    <>
                      <span>إخفاء</span>
                      <i className="fas fa-chevron-up"></i>
                    </>
                  ) : (
                    <>
                      <span>قراءة المزيد</span>
                      <i className="fas fa-chevron-down"></i>
                    </>
                  )}
                </button>
              )}
            </div>
            <div className="album-stats-row">
              <div className="stat-badge">
                <i className="fas fa-images"></i>
                <span>{data?.URLImages?.length || 0} صورة</span>
              </div>
              <div className="stat-badge">
                <i className="fas fa-calendar"></i>
                <span>ألبوم الصور</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Gallery Grid */}
      <div className="album-gallery">
        <div className="gallery-grid">
          {data?.URLImages?.map((image, index) => (
            <div 
              key={index} 
              className="gallery-item"
              onClick={() => setSelectedImage(image)}
            >
              <img src={image} alt={`صورة ${index + 1}`} loading="lazy" />
              <div className="gallery-overlay">
                <div className="zoom-icon">
                  <i className="fas fa-search-plus"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div className="image-modal" onClick={() => setSelectedImage(null)}>
          <button className="modal-close" onClick={() => setSelectedImage(null)}>
            <i className="fas fa-times"></i>
          </button>
          
          {currentImageIndex > 0 && (
            <button className="modal-nav modal-prev" onClick={handlePrevImage}>
              <i className="fas fa-chevron-right"></i>
            </button>
          )}
          
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="معاينة الصورة" className="modal-image" />
            <div className="modal-info">
              <span>صورة {currentImageIndex + 1} من {data.URLImages.length}</span>
            </div>
          </div>
          
          {currentImageIndex < data.URLImages.length - 1 && (
            <button className="modal-nav modal-next" onClick={handleNextImage}>
              <i className="fas fa-chevron-left"></i>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

// مكون منفصل لعرض ألبوم الفيديو
const VideoAlbum = () => {
  const { id } = useParams();
  const [dataVideo, setDataVideo] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeVideoId, setActiveVideoId] = useState(null);

  useEffect(() => {
    const fetchVideoAlbum = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`http://localhost:4444/videos/${id}`);
        setDataVideo(res.data.data);
      } catch (error) {
        console.error("Error fetching video album:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchVideoAlbum();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="album-container">
        <div className="loading-spinner">
          <i className="fas fa-spinner fa-spin"></i>
          <p>جاري تحميل الألبوم...</p>
        </div>
      </div>
    );
  }

  return (
    <VideoContext.Provider value={{ activeVideoId, setActiveVideoId }}>
      <div className="premium-video-album">
        {/* Video Album Hero */}
        <div className="video-album-hero">
          <div className="video-hero-background">
            <div className="video-hero-overlay"></div>
            <div className="video-hero-pattern"></div>
          </div>
          <div className="video-hero-content">
            <div className="video-hero-nav">
              <Link to="/" className="premium-back-btn">
                <i className="fas fa-arrow-left"></i>
                <span className="lang-fr">Retour</span>
                <span className="lang-ar">العودة</span>
                <span className="lang-en">Back</span>
              </Link>
            </div>
            <div className="video-hero-info">
              <div className="video-album-badge">
                <i className="fas fa-play-circle"></i>
                <span className="lang-fr">Album Vidéo</span>
                <span className="lang-ar">ألبوم الفيديو</span>
                <span className="lang-en">Video Album</span>
              </div>
              <h1 className="video-hero-title">{dataVideo?.title || 'Album Vidéo ANPE'}</h1>
              <div className="video-album-stats">
                <div className="video-stat-item">
                  <i className="fas fa-video"></i>
                  <span>{dataVideo?.Videos?.length || 0} vidéos</span>
                </div>
                <div className="video-stat-item">
                  <i className="fas fa-building"></i>
                  <span>ANPE Maroc</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Premium Video Grid */}
        <div className="premium-video-section">
          <div className="video-container">
            <div className="premium-video-grid">
              {dataVideo?.Videos?.slice().reverse().map((e, index) => (
                <div key={index} className="premium-video-card">
                  <div className="video-card-header">
                    <div className="video-number">
                      <i className="fas fa-play"></i>
                      <span>{index + 1}</span>
                    </div>
                    <div className="video-actions">
                      <button className="video-action-btn" title="Partager">
                        <i className="fas fa-share-alt"></i>
                      </button>
                    </div>
                  </div>
                  <div className="premium-video-wrapper">
                    <Video e={e} index={index} boolean={false} />
                  </div>
                  <div className="video-card-footer">
                    <div className="video-info">
                      <h3 className="video-title">{e.title || `Vidéo ${index + 1}`}</h3>
                      <p className="video-description">{e.description || 'ANPE Maroc'}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </VideoContext.Provider>
  );
};

// مكون منفصل لعرض ألبوم الصوت
const AudioAlbum = () => {
  const { id } = useParams();
  const [dataAudio, setDataAudio] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAudioAlbum = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`http://localhost:4444/audios/${id}`);
        setDataAudio(res.data.data);
      } catch (error) {
        console.error("Error fetching audio album:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchAudioAlbum();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="album-container">
        <div className="loading-spinner">
          <i className="fas fa-spinner fa-spin"></i>
          <p>جاري تحميل الألبوم...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="premium-audio-album">
      {/* Audio Album Hero */}
      <div className="audio-album-hero">
        <div className="audio-hero-background">
          <div className="audio-hero-overlay"></div>
          <div className="audio-wave-animation">
            <div className="wave"></div>
            <div className="wave"></div>
            <div className="wave"></div>
            <div className="wave"></div>
            <div className="wave"></div>
          </div>
        </div>
        <div className="audio-hero-content">
          <div className="audio-hero-nav">
            <Link to="/" className="premium-back-btn">
              <i className="fas fa-arrow-left"></i>
              <span className="lang-fr">Retour</span>
              <span className="lang-ar">العودة</span>
              <span className="lang-en">Back</span>
            </Link>
            <button className="premium-share-btn" onClick={() => {
              const shareUrl = window.location.href;
              if (navigator.share) {
                navigator.share({
                  title: dataAudio?.title || 'ANPE Maroc - Album Audio',
                  text: 'Écoutez cet album audio de ANPE Maroc',
                  url: shareUrl
                })
                  .catch(err => console.error('Erreur de partage:', err));
              } else {
                navigator.clipboard.writeText(shareUrl)
                  .then(() => alert('Lien copié au presse-papiers'))
                  .catch(err => console.error('Erreur de copie:', err));
              }
            }}>
              <i className="fas fa-share-alt"></i>
            </button>
          </div>
          <div className="audio-hero-info">
            <div className="audio-album-badge">
              <i className="fas fa-headphones"></i>
              <span className="lang-fr">Album Audio</span>
              <span className="lang-ar">ألبوم صوتي</span>
              <span className="lang-en">Audio Album</span>
            </div>
            <h1 className="audio-hero-title">{dataAudio?.title || 'Album Audio ANPE'}</h1>
            <div className="audio-album-stats">
              <div className="audio-stat-item">
                <i className="fas fa-music"></i>
                <span>{dataAudio?.Audios?.length || 0} pistes</span>
              </div>
              <div className="audio-stat-item">
                <i className="fas fa-microphone"></i>
                <span>ANPE Maroc</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Premium Audio Playlist */}
      <div className="premium-audio-section">
        <div className="audio-container">
          <div className="premium-audio-playlist">
            <div className="playlist-header">
              <h2 className="playlist-title">
                <i className="fas fa-list-ul"></i>
                <span className="lang-fr">Liste de lecture</span>
                <span className="lang-ar">قائمة التشغيل</span>
                <span className="lang-en">Playlist</span>
              </h2>
            </div>
            <div className="premium-audio-grid">
              {dataAudio?.Audios?.slice().reverse().map((e, index) => (
                <div key={index} className="premium-audio-card">
                  <div className="audio-card-header">
                    <div className="audio-number">
                      <i className="fas fa-volume-up"></i>
                      <span>{String(index + 1).padStart(2, '0')}</span>
                    </div>
                    <div className="audio-actions">
                      <button className="audio-action-btn" title="Télécharger">
                        <i className="fas fa-download"></i>
                      </button>
                      <button className="audio-action-btn" title="Partager">
                        <i className="fas fa-share-alt"></i>
                      </button>
                    </div>
                  </div>
                  <div className="premium-audio-wrapper">
                    <div className="audio-visualizer">
                      <div className="visualizer-bar"></div>
                      <div className="visualizer-bar"></div>
                      <div className="visualizer-bar"></div>
                      <div className="visualizer-bar"></div>
                      <div className="visualizer-bar"></div>
                    </div>
                    <Audio e={e} index={index} />
                  </div>
                  <div className="audio-card-footer">
                    <div className="audio-info">
                      <h3 className="audio-title">{e.title || `Audio ${index + 1}`}</h3>
                      <p className="audio-description">ANPE Maroc - Intervention</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Home />
              <SectionsMenu />
              <About />
              <Lahlou />
              <Center />
              <Contact />
            </>
          }
        />

        <Route path="/donner" element={<Donner />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/activities/:id" element={<ActivityDetail />} />
        <Route path="/all-videos" element={<VideosPage />} />
        <Route path="/all-photos" element={<PhotosPage />} />
        <Route path="/deposit-stations" element={<DepositStations />} />
        <Route path="/detail/:type/:id" element={<DetailPage />} />
        <Route path="/images/:id" element={<ImageAlbum />} />
        <Route path="/videos/:id" element={<VideoAlbum />} />
        <Route path="/audio/:id" element={<AudioAlbum />} />
        <Route path="*" element={<h1>404 Not Found</h1>} />
      </Routes>
      <ChatBotGemini />
      <Footer />
    </Router>
  );
};

export default App;